import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=28cafc3c&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cafc3c",
  null
  
)

export default component.exports